import React from "react"
import { Link, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { showAlertAction } from "../../actions/alertActions"

const SideItem = ({ title, description, link, activeMenu, setActiveMenu }) => {
	/* ******************* REDUX STORE ******************* */
	const location = useLocation()
	const dispatch = useDispatch()
	/* ******************* END REDUX STORE ******************* */

	return (
		<Link
			to={link}
			className={`hover-emerald list-group-item not-underlined text-dark border-0 left-menu-item ${
				activeMenu === title || location.pathname === link ? "left-menu-item-active" : null
			}`}
			onClick={(e) => {
				setActiveMenu(title)
				const alert1 = null
				dispatch(showAlertAction(alert1))
			}}
		>
			<div className="w-100 justify-content-between">
				<p className="h4">{title}</p>
				<p className="h6">{description}</p>
			</div>
		</Link>
	)
}

export default SideItem
